module.exports = __webpack_public_path__ + "img/img_level_3.bdda6e68.png";